import React from 'react';
import PropTypes from 'prop-types';
import List from '@/components/List';
import ListItem from '@/components/ListItem';
import Cell from '@/components/Cell';
import CellItem from '@/components/CellItem';
import Tick from '@/assets/tick.svg';
import useStyle from './style';
import cx from '@/utils/cx';


const Select = ({
  validation,
  formatter,
  options,
  value,
  onChange,
  className,
  children,
  ...rest
}) => {
  const classes = useStyle();
  const isSelected = (item) => JSON.stringify(item) === JSON.stringify(value);
  const handleSelect = (item) => onChange(options[Number(item['data-index'])]);

  return (
    <List
      className={cx(classes.select, className)}
      onItemSelect={handleSelect}
      {...rest}
    >
      { options.map((option, index) => (
        <ListItem className={cx('select-item', isSelected(option) && 'selected')} data-index={index} key={`${JSON.stringify(option)}${index + 1}`}>
          <Cell>
            <CellItem>
              <Tick />
              <span className="gap" _margin_end="md" />
            </CellItem>
            <CellItem grow _padding_end="md">
              {children(option, index)}
            </CellItem>
          </Cell>
        </ListItem>
      )) }
    </List>
  );
};

Select.propTypes = {
  options: PropTypes.array,
  /**
   * If you need custom renderer for options,
   * pass a function as children and receive current option as first argument.
   * Function(currentOption)
   * */
  children: PropTypes.func,
  value: PropTypes.any,
  onChange: PropTypes.func,
};

Select.defaultProps = {
  options: [],
  children: (option) => (
    <div _padding="md">
      {option}
    </div>
  ),
  value: undefined,
  onChange: () => {},
};

export default Select;
